module.exports = __webpack_public_path__ + "img/lv1.067e58c2.png";